import { render, staticRenderFns } from "./testForm.vue?vue&type=template&id=4798d3f0&scoped=true"
import script from "./testForm.vue?vue&type=script&lang=js"
export * from "./testForm.vue?vue&type=script&lang=js"
import style0 from "./testForm.vue?vue&type=style&index=0&id=4798d3f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798d3f0",
  null
  
)

export default component.exports